// extracted by mini-css-extract-plugin
module.exports = {"checkboxGroup":"CheckboxGroup_checkboxGroup__3xjwM","checkboxGroup__title":"CheckboxGroup_checkboxGroup__title__1aQl1","inbox":"CheckboxGroup_inbox__1yWLJ"};